export enum CART_ERROR_ID {
  CART_ISNT_READY = 'cart_isnt_ready',
  CART_NOT_FOUND = 'cart_not_found',
  INVALID_COUPON = 'invalid_coupon',
  INVALID_ITEM_QUANTITY = 'invalid_item_quantity',
  INVALID_ORDER_ACTION = 'invalid_order_action',
  INVALID_PAYMENT_PLAN = 'invalid_payment_plan',
  MINIMUM_ORDER = 'minimum_order',
  MINIMUM_ORDER_AMOUNT = 'minimum_order_amount',
  ORDER_INTEGRATION_ERROR = 'order_integration_error',
  ORDER_NOT_FOUND = 'order_not_found',
  REQUEST_BLOCKED_BY_CADASTRAL_SITUATION = 'request_blocked_by_cadastral_situation',
  BUSINESS_MODEL_NOT_FOUND = 'business_model_not_found',
}

export enum GENERIC_ERROR_ID {
  BAD_GATEWAY = 'bad_gateway',
  BAD_REQUEST = 'bad_request',
  INTERNAL_SERVER_ERROR = 'internal_server_error',
  INVALID_PARAMETER = 'invalid_parameter',
  INVALID_TOKEN_OR_EXPIRATED = 'invalid_token_or_expirated',
  LOGIN_DISABLED = 'login_disabled',
  LOGIN_ERROR = 'login_error',
  NOT_FOUND = 'not_found',
  UNAUTHORIZED = 'unauthorized',
}

export enum UNCLASSIFIED_ERROR_ID {
  INVALID_CREDENTIALS = 'invalid_credentials',
}
